/* eslint-disable */
import cx from 'classnames';
import moment from 'moment';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import { compose, withProps, withState, withHandlers, lifecycle  } from "recompose";
import { withGoogleMap, withScriptjs, GoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { MAP } from 'react-google-maps/lib/constants';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
import FontAwesome from 'react-fontawesome';

import TimeSlotsByDay from './TimeSlotsByDay';

import {
  listLocations,
  listRooms,
  listTimeSlots,
} from '../../actions';


const clusteringZoomCutoff = 10;

const MapWithControlledZoom = compose(
  withProps({
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `500px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withState('zoom', 'onZoomChange', 8),
  withHandlers(() => {
    const refs = {
      map: undefined,
    };

    let timeoutId = null;
    let didInit = false;

    return {
      onMapMounted: ({ onBoundsChanged }) => ref => {
        refs.map = ref;
        setTimeout(
          () => {
            if (didInit) return;
            didInit = true;

            console.log('init bounds!', refs.map.getBounds());
            // let delay = props.initDelay || 1;
            let delay = 100;
            onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), true, delay);

            console.log('refs.map', refs.map.context[MAP].setOptions);
            refs.map.context[MAP].setOptions({ disableDefaultUI: true });
            refs.map.context[MAP].setOptions({ zoomControl: true });
          },
          100);
      },
      onToggleOpen: ({ onToggleOpen }) => (location) => {
        onToggleOpen(location);
      },
      onZoomChanged: ({ onZoomChange }) => () => {
        onZoomChange(refs.map.getZoom());
      },
      onCenterChanged: ({ onCenterChanged }) => () => {
        // onCenterChanged(refs.map.getCenter());
      },
      onBoundsChanged: ({ onBoundsChanged }) => () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        // onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), false);
        timeoutId = setTimeout(
          () => { onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), true) },
          500,
        );
        // console.log('Timeout ID', timeoutId);
        // onBoundsChanged(refs.map.getBounds(), refs.map.getCenter(), false);
      },
    }
  }),
  withGoogleMap
)(props => {
  // console.log('render map with:', props);

  if (!props.lat || !props.lng) {
    return null;
  }

  let items = props.locations ? props.locations.items : [];
  let rooms = props.rooms ? props.rooms.items : [];

  let nodes = items.map(location => {
    let pos = { lat: parseFloat(location.lat), lng: parseFloat(location.lng) };
    let onToggleOpen = () => {
      props.onToggleOpen(location);
    };

    let isOpen = props.open && props.open.id == location.id;

    let info = null;
    if (isOpen) {
      let locationRooms = [];
      for (let r of rooms) {
        if (r.location.id == location.id) {
          locationRooms.push(r);
        }
      }

      let roomNodes = locationRooms.map(room => {
        return (
          <div className="marker-room">
            <div className="marker-room-name">{room.name}</div>
          </div>
        )
      });

      info = (
        <InfoWindow onCloseClick={props.onToggleClose}>
          <div className="marker-location">
            <div className="marker-location-name">{location.company}</div>
            <div className="marker-location-address">{location.address}</div>
          </div>
        </InfoWindow>
      );
    }

    return (
      <Marker
        key={location.id}
        position={pos}
        onClick={() => onToggleOpen()}
      >
        {isOpen && info}
      </Marker>
    );
  });

  // console.log('my zoom', props.zoom);

  if (props.zoom < clusteringZoomCutoff) {
    nodes = (
      <MarkerClusterer
        averageCenter
        enableRetinaIcons
        gridSize={50}
        onClick={props.onMarkerClustererClick}
        maxZoom={clusteringZoomCutoff}
        zoomOnClick={false}
        >
        {nodes}
      </MarkerClusterer>
    );
  }

  return (
    <div>
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: parseFloat(props.lat), lng: parseFloat(props.lng) }}
        zoom={props.zoom}
        ref={props.onMapMounted}
        onZoomChanged={props.onZoomChanged}
        onCenterChanged={props.onCenterChanged}
        onBoundsChanged={props.onBoundsChanged}
        >
        {nodes}
      </GoogleMap>
    </div>
  );
});




//   <GoogleMap
//     defaultCenter={{ lat: -34.397, lng: 150.644 }}
//     zoom={props.zoom}
//     ref={props.onMapMounted}
//     onZoomChanged={props.onZoomChanged}
//     onCenterChanged={props.onCenterChanged}
//   >
//   </GoogleMap>
// );


class MapInfoFloat extends Component {
  state = {
    active: {},
  };

  toggle(room) {
    let active = Object.assign({}, this.state.active);
    if (active[room.id]) {
      delete active[room.id];
    } else {
      active = {};
      active[room.id] = true;
      this.props.listTimeSlots({ room: room.id }, { targetKey: 'MapInfoFloat_timeSlot' });
    }
    this.setState({ active });
  }

  render() {
    let location = this.props.location;
    let rooms = this.props.rooms;
    // console.log('MapInfoFloat', rooms);

    let locationRooms = [];
    for (let r of location.rooms) {
      locationRooms.push(r);
    }

    // for (let r of rooms) {
    //   if (r.location.id == location.id) {
    //     locationRooms.push(r);
    //   }
    // }

    let roomNodes = locationRooms.map(room => {
      let active = this.state.active[room.id];

      let extraInfo;
      if (active) {
        let infoParts = [];
        if (room.minutes) infoParts.push(room.minutes + ' minutes');
        if (room.minPeople && room.maxPeople) infoParts.push(room.minPeople + '-' + room.maxPeople + ' people');
        if (room.difficulty) infoParts.push(upperFirst(room.difficulty));
        if (room.theme) infoParts.push(upperFirst(room.theme));
        // infoParts.push('id: ' + timeSlot.id);
        let info = '';
        if (infoParts.length) info = infoParts.join(', ');

        extraInfo = (
          <div className="extra-info">
            <div className="info">{info}</div>
            <div className="description">{room.description}</div>
            <TimeSlotsByDay timeSlots={this.props.timeSlots ? this.props.timeSlots.items : []} />
            <div className="controls">
              <Link to={'/r/' + room.slug + '/' + room.id}><Button bsSize="small">More Info</Button></Link>
            </div>
          </div>
        )
      }

      return (
        <div key={room.id} className={cx('marker-room', { active })}>
          <div onClick={() => this.toggle(room)} className="marker-room-name">
            <div className="name">
              {active && <FontAwesome name='chevron-circle-down' />}
              {!active && <FontAwesome name='chevron-circle-right' />}
              {' '}
              {room.name}
            </div>
          </div>
          {extraInfo}
        </div>
      )
    });
    return (
      <div className="info-float">
        <div className="info-float-close">
          <Button bsSize="xs" onClick={() => this.props.onClose()}>Close</Button>
        </div>
        <div className="location-name">{location.company}</div>
        <div className="location-address">{location.address}</div>
        <hr />
        {roomNodes}
        <hr />
        <div className="debug">
          [{location.id}]
        </div>
      </div>
    );
  }
}

MapInfoFloat = connect(
  (state) => {
    return {
      timeSlots: state.list.MapInfoFloat_timeSlot,
    };
  },
  (dispatch) => {
    return mapDispatch(dispatch, {
      listTimeSlots,
    });
  },
)(MapInfoFloat);

class RoomMap extends Component {

  constructor(props) {
    super(props);
    this.state = { center: {} };
    this.state.center.lat = props.lat;
    this.state.center.lng = props.lng;
  }

  componentDidMount() {
    // this.update();
  }

  centerChanged(googleCenter) {
    let center = {
      lat: googleCenter.lat(),
      lng: googleCenter.lng(),
    }
    // console.log('CENTER CHANGES', center);
    this.setState({ center });
    // this.props.onCenterChanged(center);
  }

  boundsChanged(googleBounds, googleCenter, shouldUpdate, delay=1) {
    let delta = {
      center: {
        lat: googleCenter.lat(),
        lng: googleCenter.lng(),
      },
      bounds: {
        northEast: {
          lat: googleBounds.getNorthEast().lat(),
          lng: googleBounds.getNorthEast().lng(),
        },
        southWest: {
          lat: googleBounds.getSouthWest().lat(),
          lng: googleBounds.getSouthWest().lng(),
        },
      },
    }
    // console.log('BOUNDS CHANGED', delta);
    this.setState(delta, () => {
      // console.log('should I update?', shouldUpdate);
      if (shouldUpdate) {
        setTimeout(() => this.update(), delay);
      }
    });
  }

  update() {
    // console.log('UPDATE', this.state.center);
    if (this.props.onUpdate) {
      this.props.onUpdate(this.state.center, this.state.bounds);
    }
    if (this.props.updateSelf) {
      this.updateQuery();
    }
  }

  updateQuery() {
    let locationParams = {
      nelat: this.state.bounds.northEast.lat,
      nelng: this.state.bounds.northEast.lng,
      swlat: this.state.bounds.southWest.lat,
      swlng: this.state.bounds.southWest.lng,
      // hideNoTimeSlots: 1,
    };
    this.props.listRooms(locationParams, { background: true, silent: true });
    this.props.listLocations(locationParams, { background: true, silent: true });
  }

  toggleOpen(location) {
    // console.log('toggleOpen::', location);
    this.setState({ open: location });
  }

  cluster(c) {
    c.getMap().setZoom(clusteringZoomCutoff);
    c.getMap().setCenter(c.getCenter());
  }

  render() {
    let locations = this.props.locations;
    let items = locations ? locations.items : [];

    let infoFloat = null;
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    if (this.state.open) {
      infoFloat = (
        <MapInfoFloat
          location={this.state.open}
          rooms={rooms}
          onClose={() => this.setState({ open: null })}
        />
      );
    }

    // console.log('render map!');

    return (
      <div>
        <div className="update-map">
        </div>
        <div className="map-wrapper">
          <MapWithControlledZoom
            isMarkerShown
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            onCenterChanged={(center) => this.centerChanged(center)}
            onBoundsChanged={(bounds, center, shouldUpdate) => this.boundsChanged(bounds, center, shouldUpdate)}
            onToggleOpen={(location) => this.toggleOpen(location)}
            onZoomChange={(zoom) => this.setState({ zoom })}
            onMarkerClustererClick={(c) => this.cluster(c)}
            open={this.state.open}
            zoom={this.state.zoom}
            {...this.props}
            >
          </MapWithControlledZoom>
          {infoFloat}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors,
    locations: state.list.location,
    rooms: state.list.room,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listLocations,
    listRooms,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoomMap);



/** WEBPACK FOOTER **
 ** ./src/components/partials/RoomMap.js
 **/